// src/utils/mergeDeep.js
const isPlainObject = (v) =>
  v != null && typeof v === "object" && !Array.isArray(v);

export function mergeDeep(target = {}, source = {}) {
  const out = { ...target };
  for (const [k, v] of Object.entries(source)) {
    if (isPlainObject(v) && isPlainObject(out[k])) {
      out[k] = mergeDeep(out[k], v);
    } else if (Array.isArray(v)) {
      // replace arrays (don’t attempt deep merge unless you truly need it)
      out[k] = [...v];
    } else {
      out[k] = v;
    }
  }
  return out;
}
